import React from "react";

import SettingIcon from "../../../imgs/settings.svg";

interface SettingsIconProps {
  onClick: () => void;
}

export default function SettingsIcon({ onClick }: SettingsIconProps) {
  return (
    <img
      src={SettingIcon}
      alt="settings"
      className="cursor-pointer"
      onClick={onClick}
    />
  );
}
